import { c as compute_rest_props, s as subscribe, n as noop } from "../../../../../../chunks/utils.js";
import { c as create_ssr_component, g as getContext, s as spread, a as escape_attribute_value, b as escape_object, d as add_attribute, e as escape, v as validate_component, i as each } from "../../../../../../chunks/ssr.js";
import "../../../../../../chunks/qualification.js";
import "../../../../../../chunks/api.js";
import { p as page } from "../../../../../../chunks/stores.js";
import { B as Button } from "../../../../../../chunks/Button.js";
import { D as Dropdown } from "../../../../../../chunks/Dropdown.js";
import { D as DropdownItem } from "../../../../../../chunks/DropdownItem.js";
import { C as Checkbox } from "../../../../../../chunks/Checkbox.js";
import { H as Heading } from "../../../../../../chunks/Heading.js";
import dayjs from "dayjs";
import { a as asValue } from "../../../../../../chunks/lenkradDate.js";
import { S as SortableTable } from "../../../../../../chunks/SortableTable.js";
import { M as Modal } from "../../../../../../chunks/Modal2.js";
import { T as Tooltip } from "../../../../../../chunks/Tooltip.js";
import { twMerge } from "tailwind-merge";
import { C as CirclePlusSolid } from "../../../../../../chunks/CirclePlusSolid.js";
import { P as PenSolid } from "../../../../../../chunks/PenSolid.js";
import { M as ModalFooter, a as ModalHeader, T as TrashBinSolid } from "../../../../../../chunks/ModalHeader.js";
import { g as globalConfirm } from "../../../../../../chunks/modal.js";
import { g as globalToast } from "../../../../../../chunks/toast2.js";
import "../../../../../../chunks/client.js";
import { m as mailTemplates, q as qualifications, R as ReentryModal } from "../../../../../../chunks/ReentryModal.js";
import { t as templateDocuments } from "../../../../../../chunks/generateContractPreview.js";
import { B as BuildingSolid } from "../../../../../../chunks/BuildingSolid.js";
import { a as allUnits } from "../../../../../../chunks/unit.js";
import "@tiptap/extension-link";
import "../../../../../../chunks/TipTapEditor.js";
import { L as Label } from "../../../../../../chunks/Label.js";
import { F as Fileupload } from "../../../../../../chunks/Fileupload.js";
import { I as Input } from "../../../../../../chunks/Input.js";
import "../../../../../../chunks/files.js";
import { E as EnvelopeSolid } from "../../../../../../chunks/EnvelopeSolid.js";
import { C as CardLayout } from "../../../../../../chunks/CardLayout.js";
import { V as VerticalGrid, E as EmployeeInfo, Q as Qualifications, T as TaxAndInsurance, B as BankAccount } from "../../../../../../chunks/TaxAndInsurance.js";
import { I as InfoBox } from "../../../../../../chunks/InfoBox.js";
import { w as writable } from "../../../../../../chunks/index2.js";
import { t as tariffs } from "../../../../../../chunks/tariffs.js";
import { S as Select } from "../../../../../../chunks/Select.js";
import { H as Hr } from "../../../../../../chunks/Hr.js";
import { c as contractTypes } from "../../../../../../chunks/contractTypes.js";
import { f as formatCurrency } from "../../../../../../chunks/currency.js";
import "../../../../../../chunks/convertPdfToImage.js";
import { l as listView } from "../../../../../../chunks/viewStore.js";
const ArrowsRepeatOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "arrows repeat outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3"></path></svg>`} `;
});
const ParagraphSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "paragraph solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M8.5 4a4.5 4.5 0 0 0 0 9H11v6a1 1 0 1 0 2 0V6h2v13a1 1 0 1 0 2 0V6h2a1 1 0 1 0 0-2H8.5Z" clip-rule="evenodd"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M8.5 4a4.5 4.5 0 0 0 0 9H11v6a1 1 0 1 0 2 0V6h2v13a1 1 0 1 0 2 0V6h2a1 1 0 1 0 0-2H8.5Z" clip-rule="evenodd"></path></svg>`} `;
});
const ContractStatusCard = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_tariffs;
  $$unsubscribe_tariffs = subscribe(tariffs, (value) => value);
  let { contract } = $$props;
  let { employee } = $$props;
  if ($$props.contract === void 0 && $$bindings.contract && contract !== void 0) $$bindings.contract(contract);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  $$unsubscribe_tariffs();
  return `<div>${``}</div>`;
});
const ProlongingContractModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_mailTemplates;
  let $$unsubscribe_allUnits;
  $$unsubscribe_mailTemplates = subscribe(mailTemplates, (value) => value);
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => value);
  let { open } = $$props;
  let { currentContract } = $$props;
  let { employee } = $$props;
  let submitting = false;
  ({
    newEndDate: dayjs().add(6, "months").format("YYYY-MM-DD"),
    contract: currentContract
  });
  let preview;
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.currentContract === void 0 && $$bindings.currentContract && currentContract !== void 0) $$bindings.currentContract(currentContract);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "lg",
        title: "Vertrag verlängen",
        open
      },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render(
            $$result,
            {
              disabled: submitting,
              showEdit: !!preview
            },
            {},
            {
              right: () => {
                return `${`${validate_component(Button, "Button").$$render(
                  $$result,
                  {
                    disabled: submitting,
                    class: "bg-sky-100 text-neutral-700 whitespace-nowrap"
                  },
                  {},
                  {
                    default: () => {
                      return `${validate_component(BuildingSolid, "BuildingSolid").$$render($$result, { class: "w-4 mr-2" }, {}, {})}Vorschau erstellen`;
                    }
                  }
                )}`}`;
              }
            }
          )} `;
        },
        header: () => {
          return `${validate_component(ModalHeader, "ModalHeader").$$render($$result, {}, {}, {
            default: () => {
              return `Vertrag verlängen`;
            }
          })} `;
        },
        default: () => {
          return `${`Kann nicht verlängt werden.`} ${``}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_mailTemplates();
  $$unsubscribe_allUnits();
  return $$rendered;
});
const RetireContractModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_allUnits;
  let $$unsubscribe_templateDocuments;
  let $$unsubscribe_mailTemplates;
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => value);
  $$unsubscribe_templateDocuments = subscribe(templateDocuments, (value) => value);
  $$unsubscribe_mailTemplates = subscribe(mailTemplates, (value) => value);
  let { open = false } = $$props;
  let { contract } = $$props;
  let { externally = false } = $$props;
  let { employee } = $$props;
  let retireData = {
    endDate: dayjs().add(1, "month").set("date", 1).subtract(1, "day").format("YYYY-MM-DD"),
    files: void 0
  };
  let previewForm;
  let preview;
  let loading = false;
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.contract === void 0 && $$bindings.contract && contract !== void 0) $$bindings.contract(contract);
  if ($$props.externally === void 0 && $$bindings.externally && externally !== void 0) $$bindings.externally(externally);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "lg",
        title: "Vertrag auflösen",
        open
      },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render($$result, { disabled: loading, showEdit: !!preview }, {}, {
            right: () => {
              return `${`${validate_component(Button, "Button").$$render(
                $$result,
                {
                  disabled: loading,
                  class: "bg-sky-100 text-neutral-600"
                },
                {},
                {
                  default: () => {
                    return `${escape(externally ? "Kündigung einreichen" : "Auflösen")}`;
                  }
                }
              )}`}`;
            }
          })} `;
        },
        header: () => {
          return `${validate_component(ModalHeader, "ModalHeader").$$render($$result, {}, {}, {
            default: () => {
              return `Vertrag auflösen`;
            }
          })} `;
        },
        default: () => {
          return `${`<p data-svelte-h="svelte-2la5mu">Vertrag auflösen?</p> <form class="space-y-3"${add_attribute("this", previewForm, 0)}>${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-tm9e4q">Zum</span> ${validate_component(Input, "Input").$$render(
                $$result,
                {
                  type: "date",
                  required: true,
                  value: retireData.endDate
                },
                {
                  value: ($$value) => {
                    retireData.endDate = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${externally ? `${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-1awgxzr">Dokument</span> ${validate_component(Fileupload, "Fileupload").$$render(
                $$result,
                { required: true, files: retireData.files },
                {
                  files: ($$value) => {
                    retireData.files = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}` : ``}</form>`}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_allUnits();
  $$unsubscribe_templateDocuments();
  $$unsubscribe_mailTemplates();
  return $$rendered;
});
const AdjustContractHoursModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_mailTemplates;
  let $$unsubscribe_allUnits;
  let $$unsubscribe_doneModal;
  $$unsubscribe_mailTemplates = subscribe(mailTemplates, (value) => value);
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => value);
  let { open = false } = $$props;
  let { contract } = $$props;
  let { employee } = $$props;
  let preview = null;
  let previewForm;
  let doneModal = getContext("doneModal");
  $$unsubscribe_doneModal = subscribe(doneModal, (value) => value);
  let changeData = {
    input: contract.currentHistory.workDaysPerWeek,
    when: dayjs().add(1, "month").set("date", 1).format("YYYY-MM-DD")
  };
  ({
    ...contract.currentHistory,
    id: null,
    historyType: "adjustment-hours"
  });
  let loading = false;
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.contract === void 0 && $$bindings.contract && contract !== void 0) $$bindings.contract(contract);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "lg",
        title: "Stundenanpassung",
        open
      },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render($$result, { showEdit: !!preview, disabled: loading }, {}, {
            right: () => {
              return `${`${validate_component(Button, "Button").$$render(
                $$result,
                {
                  class: "bg-sky-100 text-neutral-600 whitespace-nowrap"
                },
                {},
                {
                  default: () => {
                    return `${validate_component(EnvelopeSolid, "EnvelopeSolid").$$render($$result, { class: "w-4 mr-2" }, {}, {})}Vorschau erzeugen`;
                  }
                }
              )}`}`;
            }
          })} `;
        },
        header: () => {
          return `${validate_component(ModalHeader, "ModalHeader").$$render($$result, {}, {}, {
            default: () => {
              return `Stundenanpassung`;
            }
          })} `;
        },
        default: () => {
          return `${`${validate_component(CardLayout, "CardLayout").$$render($$result, { title: "Aktueller Vertrag" }, {}, {
            default: () => {
              return `${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
                right: () => {
                  return `${validate_component(InfoBox, "InfoBox").$$render(
                    $$result,
                    {
                      title: "Neue Arbeitstage",
                      value: changeData.input + " Tage/Woche"
                    },
                    {},
                    {}
                  )} ${validate_component(InfoBox, "InfoBox").$$render(
                    $$result,
                    {
                      title: "Neue Arbeitsstunden",
                      value: (contract.currentHistory.workHoursPerDay * changeData.input * 4.3).toFixed(0) + " Stunden/Monat"
                    },
                    {},
                    {}
                  )} `;
                },
                default: () => {
                  return `${validate_component(InfoBox, "InfoBox").$$render(
                    $$result,
                    {
                      title: "Aktuelle Arbeitstage",
                      value: contract.currentHistory.workDaysPerWeek + " Tage/Woche"
                    },
                    {},
                    {}
                  )} ${validate_component(InfoBox, "InfoBox").$$render(
                    $$result,
                    {
                      title: "Aktuelle Arbeitsstunden",
                      value: (contract.currentHistory.workHoursPerDay * contract.currentHistory.workDaysPerWeek * 4.3).toFixed(0) + " Stunden/Monat"
                    },
                    {},
                    {}
                  )}`;
                }
              })}`;
            }
          })} <form class="flex gap-3"${add_attribute("this", previewForm, 0)}>${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 flex-1" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-uw6z8q">Arbeitstage pro Woche</span> ${validate_component(Input, "Input").$$render(
                $$result,
                {
                  disabled: !!preview,
                  required: true,
                  step: "0.5",
                  type: "number",
                  value: changeData.input
                },
                {
                  value: ($$value) => {
                    changeData.input = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-tm9e4q">Zum</span> ${validate_component(Input, "Input").$$render(
                $$result,
                {
                  disabled: !!preview,
                  required: true,
                  type: "date",
                  value: changeData.when
                },
                {
                  value: ($$value) => {
                    changeData.when = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}</form>`}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_mailTemplates();
  $$unsubscribe_allUnits();
  $$unsubscribe_doneModal();
  return $$rendered;
});
const ChangeTariffModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $qualifications, $$unsubscribe_qualifications;
  let $$unsubscribe_mailTemplates;
  let $tariffs, $$unsubscribe_tariffs;
  let $$unsubscribe_allUnits;
  let $$unsubscribe_templateDocuments;
  let $$unsubscribe_forceEditable;
  let $$unsubscribe_doneModal;
  $$unsubscribe_qualifications = subscribe(qualifications, (value) => $qualifications = value);
  $$unsubscribe_mailTemplates = subscribe(mailTemplates, (value) => value);
  $$unsubscribe_tariffs = subscribe(tariffs, (value) => $tariffs = value);
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => value);
  $$unsubscribe_templateDocuments = subscribe(templateDocuments, (value) => value);
  let { open = false } = $$props;
  let { currentContract } = $$props;
  let { employee } = $$props;
  let preview;
  let doneModal = getContext("doneModal");
  $$unsubscribe_doneModal = subscribe(doneModal, (value) => value);
  let newTariffObject = {
    originalHistoryId: null,
    newTariffId: null,
    switchDate: dayjs().add(1, "month").set("date", 1).format("YYYY-MM-DD"),
    file: null,
    newQualificationId: void 0
  };
  let loading = false;
  let forceEditable = writable(true);
  $$unsubscribe_forceEditable = subscribe(forceEditable, (value) => value);
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.currentContract === void 0 && $$bindings.currentContract && currentContract !== void 0) $$bindings.currentContract(currentContract);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      {
        $tariffs.find((x) => x.id === newTariffObject.newTariffId)?.qualifications?.map((x) => ({
          value: x.qualificationId,
          name: $qualifications.find((y) => y.id === x.qualificationId)?.title
        }));
      }
    }
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "lg",
        title: "Tarif/Qualifikation ändern",
        open
      },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render($$result, { disabled: loading, showEdit: !!preview }, {}, {
            right: () => {
              return `${`${validate_component(Button, "Button").$$render(
                $$result,
                {
                  disabled: loading,
                  class: "bg-sky-100 text-neutral-600 whitespace-nowrap"
                },
                {},
                {
                  default: () => {
                    return `Vorschau erstellen`;
                  }
                }
              )}`}`;
            }
          })} `;
        },
        header: () => {
          return `${validate_component(ModalHeader, "ModalHeader").$$render($$result, {}, {}, {
            default: () => {
              return `Tarif/Qualifikation ändern`;
            }
          })} `;
        },
        default: () => {
          return `${`${``}`}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_qualifications();
  $$unsubscribe_mailTemplates();
  $$unsubscribe_tariffs();
  $$unsubscribe_allUnits();
  $$unsubscribe_templateDocuments();
  $$unsubscribe_forceEditable();
  $$unsubscribe_doneModal();
  return $$rendered;
});
const ChangeGroupModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_tariffs;
  let $$unsubscribe_templateDocuments;
  let $$unsubscribe_mailTemplates;
  let $allUnits, $$unsubscribe_allUnits;
  let $formStatus, $$unsubscribe_formStatus = noop, $$subscribe_formStatus = () => ($$unsubscribe_formStatus(), $$unsubscribe_formStatus = subscribe(formStatus, ($$value) => $formStatus = $$value), formStatus);
  let $$unsubscribe_doneModal;
  $$unsubscribe_tariffs = subscribe(tariffs, (value) => value);
  $$unsubscribe_templateDocuments = subscribe(templateDocuments, (value) => value);
  $$unsubscribe_mailTemplates = subscribe(mailTemplates, (value) => value);
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => $allUnits = value);
  let { open = false } = $$props;
  let { employee } = $$props;
  let { contract } = $$props;
  let proceedForm;
  let formStatus = writable({
    loading: false,
    preview: null,
    formComplete: false,
    triggerPreview: false,
    triggerContract: false
  });
  $$subscribe_formStatus();
  ({
    link: "https://goolge.com",
    localContractType: "test",
    formerLocalContractType: contractTypes.find((t) => t.value === contract.contractType).name,
    formerLink: null,
    formerEndDate: contract.currentHistory.endDate
  });
  let doneModal = getContext("doneModal");
  $$unsubscribe_doneModal = subscribe(doneModal, (value) => value);
  let groups = [];
  let newContract = {
    contractType: "workingstudent",
    currentHistory: {
      id: null,
      startDate: dayjs().add(1, "month").date(1).format("YYYY-MM-DD"),
      endDate: dayjs(asValue(contract.currentHistory.endDate)).format("YYYY-MM-DD"),
      tariffId: contract.currentHistory.tariffId,
      hiredAs: "ServicehilfKraft",
      qualificationId: contract.currentHistory.qualificationId
    },
    history: void 0
  };
  let preview;
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  if ($$props.contract === void 0 && $$bindings.contract && contract !== void 0) $$bindings.contract(contract);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        title: "Vertragsart-Änderung}",
        size: "xl",
        open
      },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render(
            $$result,
            {
              disabled: $formStatus.loading,
              showEdit: !!preview
            },
            {},
            {
              right: () => {
                return `${`${validate_component(Button, "Button").$$render(
                  $$result,
                  {
                    class: "bg-sky-100 text-neutral-600 whitespace-nowrap",
                    disabled: $formStatus.loading
                  },
                  {},
                  {
                    default: () => {
                      return `Vertragsangebot erstellen`;
                    }
                  }
                )}`}`;
              }
            }
          )} `;
        },
        header: () => {
          return `${validate_component(ModalHeader, "ModalHeader").$$render($$result, {}, {}, {
            default: () => {
              return `Vertragsart-Änderung`;
            }
          })} `;
        },
        default: () => {
          return `<div class="mt-3 space-y-3">${validate_component(Heading, "Heading").$$render(
            $$result,
            {
              tag: "h3",
              class: "text-neutral-600 pl-2"
            },
            {},
            {
              default: () => {
                return `Bestehender Arbeitsvertrag  ${escape(employee.firstName)} ${escape(employee.lastName)}`;
              }
            }
          )} ${validate_component(EmployeeInfo, "EmployeeInfo").$$render($$result, { display: false, readOnly: true }, {}, {})} ${validate_component(Qualifications, "Qualifications").$$render($$result, { display: false, readOnly: true }, {}, {})} ${validate_component(TaxAndInsurance, "TaxAndInsurance").$$render($$result, { display: false, readOnly: true }, {}, {})} ${validate_component(BankAccount, "BankAccount").$$render($$result, { display: false, readOnly: true }, {}, {})}</div> ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} ${validate_component(Heading, "Heading").$$render(
            $$result,
            {
              tag: "h3",
              class: "text-neutral-600 pl-2"
            },
            {},
            {
              default: () => {
                return `Neue Vertragsart  ${escape(employee.firstName)} ${escape(employee.lastName)}`;
              }
            }
          )} <form${add_attribute("this", proceedForm, 0)}>${validate_component(CardLayout, "CardLayout").$$render(
            $$result,
            {
              title: "Vertragsart-Änderung",
              accordion: true
            },
            {},
            {
              default: () => {
                return ` ${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
                  right: () => {
                    return `${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Zeitraum",
                        value: dayjs(asValue(contract.currentHistory.startDate)).format("DD.MM.YYYY") + " - " + dayjs(asValue(contract.currentHistory.endDate)).format("DD.MM.YYYY")
                      },
                      {},
                      {}
                    )} ${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Stunden",
                        value: contract.currentHistory.monthlyHours
                      },
                      {},
                      {}
                    )} ${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Unit",
                        value: $allUnits.find((x) => x.id === employee.unitId)?.name
                      },
                      {},
                      {}
                    )} <div class="h-12"></div> ${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Neuer Vertragsart",
                        value: contractTypes.find((x) => x.value === newContract.contractType)?.name
                      },
                      {},
                      {}
                    )} ${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Beginn neuer Vertrag",
                        value: dayjs(asValue(newContract.currentHistory.startDate)).format("DD.MM.YYYY")
                      },
                      {},
                      {}
                    )} `;
                  },
                  default: () => {
                    return `${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Bestehender Grundlohn",
                        value: formatCurrency(employee.currentContract.currentHistory.wagePerHour)
                      },
                      {},
                      {}
                    )} ${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Bestehende Akontozahlung",
                        value: formatCurrency(employee.currentContract.currentHistory.paymentOnAccount)
                      },
                      {},
                      {}
                    )} ${validate_component(InfoBox, "InfoBox").$$render($$result, { title: "Status", value: employee.status }, {}, {})} ${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Qualifikation",
                        value: contract.currentHistory.hiredAs
                      },
                      {},
                      {}
                    )} ${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Bestehender Vertragsart",
                        value: contractTypes.find((x) => x.value === employee.currentContract?.contractType)?.name
                      },
                      {},
                      {}
                    )} ${validate_component(InfoBox, "InfoBox").$$render(
                      $$result,
                      {
                        title: "Auflösung bestehender Vertrag",
                        value: dayjs(asValue(newContract.currentHistory.startDate)).subtract(1, "day").format("DD.MM.YYYY")
                      },
                      {},
                      {}
                    )}`;
                  }
                })} ${!$formStatus.preview ? `<div class="flex gap-2 p-2 pt-4 mb-5">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 flex-1" }, {}, {
                  default: () => {
                    return `<span data-svelte-h="svelte-1ype88c">Neuer Vertragsart</span> ${validate_component(Select, "Select").$$render(
                      $$result,
                      { value: newContract.contractType },
                      {
                        value: ($$value) => {
                          newContract.contractType = $$value;
                          $$settled = false;
                        }
                      },
                      {
                        default: () => {
                          return `${each(groups, (group) => {
                            return `<option${add_attribute("value", group.value, 0)} ${employee.currentContract?.contractType === group.value ? "disabled" : ""}>${escape(group.name)}</option>`;
                          })}`;
                        }
                      }
                    )}`;
                  }
                })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
                  default: () => {
                    return `<span data-svelte-h="svelte-tm9e4q">Zum</span> ${validate_component(Input, "Input").$$render(
                      $$result,
                      {
                        type: "date",
                        value: newContract.currentHistory.startDate
                      },
                      {
                        value: ($$value) => {
                          newContract.currentHistory.startDate = $$value;
                          $$settled = false;
                        }
                      },
                      {}
                    )}`;
                  }
                })}</div>` : ``}`;
              }
            }
          )}</form> ${`${``}`}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_tariffs();
  $$unsubscribe_templateDocuments();
  $$unsubscribe_mailTemplates();
  $$unsubscribe_allUnits();
  $$unsubscribe_formStatus();
  $$unsubscribe_doneModal();
  return $$rendered;
});
const ContractActions = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_globalToast;
  let $$unsubscribe_globalConfirm;
  $$unsubscribe_globalToast = subscribe(globalToast, (value) => value);
  $$unsubscribe_globalConfirm = subscribe(globalConfirm, (value) => value);
  let { contract } = $$props;
  let { currentContract } = $$props;
  let { employee } = $$props;
  let retireModal = false;
  let reentryModal = false;
  let externalRetirement = false;
  let syncModal = false;
  let adjustHoursModal = false;
  let changeTariffModal = false;
  let changeGroupModal = false;
  let isActive = false;
  let contractStati = {
    "signed": "Unterschrieben",
    "planned": "Geplant",
    "waiting_for_employee_signature": "Erwarte Signatur des Mitarbeiters",
    "waiting_for_hr_signature": "Erwarte Signatur von HR",
    "synchronized": "Arbeitsvertrag"
  };
  let prolongingModal = false;
  let loading = false;
  if ($$props.contract === void 0 && $$bindings.contract && contract !== void 0) $$bindings.contract(contract);
  if ($$props.currentContract === void 0 && $$bindings.currentContract && currentContract !== void 0) $$bindings.currentContract(currentContract);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    contract.id === currentContract?.id;
    {
      {
        if (contract.completeTimeframe.endDate.value) {
          isActive = dayjs().isBefore(dayjs(asValue(contract.history.find((x) => x.historyType === "document" && x.hiredAs.includes("(aufgelöst)"))?.endDate || contract.currentHistory.endDate)));
        } else {
          isActive = true;
        }
      }
    }
    $$rendered = `${validate_component(ChangeGroupModal, "ChangeGroupModal").$$render(
      $$result,
      {
        contract: currentContract ?? contract,
        employee,
        open: changeGroupModal
      },
      {
        open: ($$value) => {
          changeGroupModal = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(RetireContractModal, "RetireContractModal").$$render(
      $$result,
      {
        contract: currentContract ?? contract,
        employee,
        externally: externalRetirement,
        open: retireModal
      },
      {
        open: ($$value) => {
          retireModal = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(ProlongingContractModal, "ProlongingContractModal").$$render(
      $$result,
      {
        currentContract: currentContract ?? contract,
        employee,
        open: prolongingModal
      },
      {
        open: ($$value) => {
          prolongingModal = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(ReentryModal, "ReentryModal").$$render(
      $$result,
      { contract, employee, open: reentryModal },
      {
        open: ($$value) => {
          reentryModal = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(AdjustContractHoursModal, "AdjustContractHoursModal").$$render(
      $$result,
      {
        contract,
        employee,
        open: adjustHoursModal
      },
      {
        open: ($$value) => {
          adjustHoursModal = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(ChangeTariffModal, "ChangeTariffModal").$$render(
      $$result,
      {
        currentContract: currentContract ?? contract,
        employee,
        open: changeTariffModal
      },
      {
        open: ($$value) => {
          changeTariffModal = $$value;
          $$settled = false;
        }
      },
      {}
    )} <div class="h-full flex flex-col">${validate_component(Heading, "Heading").$$render(
      $$result,
      {
        tag: "h5",
        class: "text-neutral-600 mb-3"
      },
      {},
      {
        default: () => {
          return `Status: <span class="text-primary-600">${escape(contractStati[contract.employmentContractStatus])}</span>`;
        }
      }
    )} ${!contract.completeTimeframe.endDate.value || dayjs().isBefore(dayjs(contract.completeTimeframe.endDate.value ?? "")) ? `<div class="flex flex-col gap-3 flex-1">${contract.employmentContractStatus !== "synchronized" || contract.history.find((x) => x.employmentContractStatus !== "synchronized") ? `${validate_component(Button, "Button").$$render(
      $$result,
      {
        color: "red",
        size: "sm",
        outline: true,
        pill: true
      },
      {},
      {
        default: () => {
          return `${validate_component(TrashBinSolid, "TrashBinSolid").$$render($$result, { class: "pr-1" }, {}, {})}
                    Zurückziehen`;
        }
      }
    )} ${validate_component(Button, "Button").$$render(
      $$result,
      {
        color: "red",
        size: "sm",
        outline: true,
        pill: true
      },
      {},
      {
        default: () => {
          return `${validate_component(TrashBinSolid, "TrashBinSolid").$$render($$result, { class: "pr-1" }, {}, {})}
                    Abbrechen (*?)`;
        }
      }
    )} ${validate_component(Tooltip, "Tooltip").$$render($$result, {}, {}, {
      default: () => {
        return `One E-Mail an den Mitarbeiter`;
      }
    })}` : `${contract.employmentContractStatus === "signed" ? `${validate_component(Button, "Button").$$render(
      $$result,
      {
        size: "sm",
        outline: true,
        pill: true,
        color: "light"
      },
      {},
      {
        default: () => {
          return `${validate_component(ArrowsRepeatOutline, "ArrowsRepeatOutline").$$render($$result, { class: "pr-1" }, {}, {})}
                    (re-)sync`;
        }
      }
    )}` : `${validate_component(Button, "Button").$$render($$result, { size: "sm", outline: true, pill: true }, {}, {
      default: () => {
        return `${validate_component(PenSolid, "PenSolid").$$render($$result, { class: "pr-1" }, {}, {})}
                    Ändern`;
      }
    })} ${validate_component(Dropdown, "Dropdown").$$render($$result, {}, {}, {
      default: () => {
        return `${isActive ? `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Tarif/Qualifikations-Änderung`;
          }
        })} ${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Vertragsart-Änderung`;
          }
        })} ${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Stundenanpassung`;
          }
        })} ${contract.completeTimeframe.endDate.value ? `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Verlängern`;
          }
        })}` : ``}` : `${dayjs(asValue(contract.currentHistory.endDate)).isAfter(dayjs().subtract(30, "days")) ? `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Verlängern`;
          }
        })} ${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Wiedereinstieg`;
          }
        })}` : `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Wiedereinstieg`;
          }
        })}`}`} `;
      }
    })} ${validate_component(Button, "Button").$$render(
      $$result,
      {
        size: "sm",
        outline: true,
        pill: true,
        color: "yellow"
      },
      {},
      {
        default: () => {
          return `${validate_component(ParagraphSolid, "ParagraphSolid").$$render($$result, { class: "pr-1" }, {}, {})}
                    Auflösen`;
        }
      }
    )} ${validate_component(Dropdown, "Dropdown").$$render($$result, {}, {}, {
      default: () => {
        return `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Kündigen`;
          }
        })} ${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Kündigung erhalten`;
          }
        })} ${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Nicht angetreten`;
          }
        })}`;
      }
    })} ${validate_component(Button, "Button").$$render($$result, { size: "sm", outline: true, pill: true }, {}, {
      default: () => {
        return `${validate_component(CirclePlusSolid, "CirclePlusSolid").$$render($$result, { class: "pr-1" }, {}, {})}
                    Dokument`;
      }
    })} ${validate_component(Dropdown, "Dropdown").$$render($$result, {}, {}, {
      default: () => {
        return `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Abmahnung`;
          }
        })} ${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Sondervereinbarung`;
          }
        })} ${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
          default: () => {
            return `Sonstiges/Upload`;
          }
        })}`;
      }
    })} <div class="flex-1"></div> ${validate_component(Button, "Button").$$render(
      $$result,
      {
        disabled: loading,
        size: "sm",
        outline: true,
        pill: true,
        color: "light"
      },
      {},
      {
        default: () => {
          return `${validate_component(ArrowsRepeatOutline, "ArrowsRepeatOutline").$$render($$result, { class: "pr-1" }, {}, {})}
                    (re-)sync`;
        }
      }
    )}`}`}</div>` : `<span data-svelte-h="svelte-xxbldu">Abgelaufen</span> ${validate_component(Button, "Button").$$render(
      $$result,
      {
        disabled: loading,
        class: "mt-7",
        size: "sm",
        outline: true,
        pill: true,
        color: "light"
      },
      {},
      {
        default: () => {
          return `${validate_component(ArrowsRepeatOutline, "ArrowsRepeatOutline").$$render($$result, { class: "pr-1" }, {}, {})}
            (re-)sync`;
        }
      }
    )}`} ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        title: "Synchronisation",
        open: syncModal
      },
      {
        open: ($$value) => {
          syncModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<p data-svelte-h="svelte-j55aao">Vertrag zu Drittanbietern übertragen?</p> <p class="text-primary-600">${escape("")}</p> ${validate_component(Button, "Button").$$render($$result, { color: "light" }, {}, {
            default: () => {
              return `Synchronisieren`;
            }
          })}`;
        }
      }
    )}</div>`;
  } while (!$$settled);
  $$unsubscribe_globalToast();
  $$unsubscribe_globalConfirm();
  return $$rendered;
});
const elseHeader = [
  {
    label: "Datum",
    sortable: true,
    movable: true,
    property: "createdAt",
    render: (row) => dayjs(asValue(row.createdAt)).format("DD.MM.YYYY")
  },
  {
    label: "Dokument",
    sortable: true,
    movable: true,
    property: "contractDocument",
    render: (row) => row.contractDocument?.location ? '<a href="' + row.contractDocument.location + '" target="_blank" rel="noreferrer noopener">' + row.contractDocument.name + "</a>" : "Kein Dokument"
  },
  {
    label: "Ende der Tätigkeit",
    movable: true,
    property: "endDate",
    sortable: true,
    render: (row) => dayjs(asValue(row.endDate)).format("DD.MM.YYYY")
  },
  {
    label: "Berifft",
    movable: true,
    property: "contractDocument",
    render: (row) => row.hiredAs
  }
];
const ptoHeader = [
  {
    label: "Von",
    sortable: true,
    movable: true,
    property: "startDate",
    class: "w-28",
    render: (row) => colored(row, dayjs(asValue(row.startDate)).format("DD.MM.YYYY"))
  },
  {
    label: "Bis",
    sortable: true,
    movable: true,
    property: "startDate",
    render: (row) => colored(row, whenTerminatedEnd(row))
  },
  {
    label: "Urlaubstage",
    sortable: true,
    movable: true,
    property: "ptoDays"
  },
  {
    label: "HistoryID",
    movable: true,
    sortable: true,
    property: "id"
  }
];
const whenTerminatedEnd = (row) => {
  return row.terminated ? dayjs(asValue(row.terminated)).format("DD.MM.YYYY") + ' (<span class="line-through">' + renderDate(row.endDate) + "</span>)" : renderDate(row.endDate);
};
const renderDate = (potentialDate) => {
  if (asValue(potentialDate)) {
    return dayjs(asValue(potentialDate)).format("DD.MM.YYYY");
  }
  return "unbefristet";
};
const colored = (row, text) => {
  let color = "";
  const now = (/* @__PURE__ */ new Date()).getTime();
  if (row.employmentContractStatus !== "synchronized") {
    color = "text-primary-600";
  } else if (row.startDate.stamp * 1e3 > now) {
    color = "text-secondary-700";
  } else if (row.endDate.stamp * 1e3 < now || row.terminated && row.terminated.stamp * 1e3 < now) {
    color = "text-neutral-400";
  }
  return `<span class="${color}">${text}</span>`;
};
const costCenters = writable([]);
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let contracts;
  let $$unsubscribe_costCenters;
  let $$unsubscribe_templateDocuments;
  let $$unsubscribe_tariffs;
  let $$unsubscribe_qualifications;
  let $page, $$unsubscribe_page;
  let $listView, $$unsubscribe_listView;
  $$unsubscribe_costCenters = subscribe(costCenters, (value) => value);
  $$unsubscribe_templateDocuments = subscribe(templateDocuments, (value) => value);
  $$unsubscribe_tariffs = subscribe(tariffs, (value) => value);
  $$unsubscribe_qualifications = subscribe(qualifications, (value) => value);
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  $$unsubscribe_listView = subscribe(listView, (value) => $listView = value);
  let employee = $page.data.employee;
  let listedHistory = employee.contracts.map((x) => x.history.map((h) => ({
    ...h,
    terminated: x.history.find((y) => y.hiredAs.includes("(aufgelöst)"))?.endDate
  }))).flat();
  let localQualifications = [];
  let localHeader = { contractHeader: [], tariffHeader: [] };
  let filteredHeaderItems = { contractHeader: [], tariffHeader: [] };
  let color = "text-neutral-600";
  const parseTimeframe = (contract) => {
    if (!contract.currentHistory || typeof contract.currentHistory.startDate === "undefined") {
      return "";
    }
    const from = dayjs(asValue(contract.completeTimeframe.startDate)).format("DD.MM.YYYY");
    const modifiedHistory = contract.history.find((x) => x.historyType === "document" && x.hiredAs.includes("(aufgelöst)"));
    const to = modifiedHistory ? dayjs(asValue(modifiedHistory.endDate)).format("DD.MM.YYYY") + ' <span class="text-red-600 line-through">(' + dayjs(asValue(contract.currentHistory.endDate)).format("DD.MM.YYYY") + ")</span>" : !asValue(contract.completeTimeframe.endDate) ? "unbefristet" : dayjs(asValue(contract.currentHistory.endDate)).format("DD.MM.YYYY");
    color = "text-neutral-600";
    if (dayjs().isAfter(modifiedHistory ? dayjs(asValue(modifiedHistory.endDate)) : dayjs(asValue(contract.currentHistory.endDate)))) {
      color = "text-neutral-400";
    } else if (contract.currentHistory.employmentContractStatus !== "synchronized") {
      color = "text-primary-500";
    }
    return `<span class="${color}">` + from + " - " + to + `</span> | <span class="${color}"> ${contract.currentHistory.group} </span> | <span class="${color}"> ${localQualifications.find((x) => x.id === contract.currentHistory.qualificationId)?.title || contract.currentHistory.hiredAs}</span>`;
  };
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    contracts = employee.contracts.sort((a, b) => b.id - a.id);
    $$rendered = `<div>${$listView ? `<div><div class="flex justify-between items-center">${validate_component(Heading, "Heading").$$render(
      $$result,
      {
        class: "text-neutral-600 mb-3",
        tag: "h4"
      },
      {},
      {
        default: () => {
          return `Tarif`;
        }
      }
    )} <div>${validate_component(Button, "Button").$$render($$result, { size: "sm" }, {}, {
      default: () => {
        return `Felder`;
      }
    })} ${validate_component(Dropdown, "Dropdown").$$render($$result, {}, {}, {
      default: () => {
        return `${each([...localHeader.tariffHeader, ...filteredHeaderItems.tariffHeader].sort((a, b) => a.label.localeCompare(b.label)), (header) => {
          return `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
            default: () => {
              return `${validate_component(Checkbox, "Checkbox").$$render(
                $$result,
                {
                  checked: filteredHeaderItems.tariffHeader.find((x) => x.label === header.label) === void 0
                },
                {},
                {
                  default: () => {
                    return `${escape(header.label)}`;
                  }
                }
              )} `;
            }
          })}`;
        })}`;
      }
    })}</div></div> ${validate_component(SortableTable, "SortableTable").$$render(
      $$result,
      {
        header: localHeader.tariffHeader,
        data: listedHistory.filter((x) => x.historyType !== "document")
      },
      {},
      {}
    )} <div class="flex justify-between items-center">${validate_component(Heading, "Heading").$$render(
      $$result,
      {
        class: "text-neutral-600 my-3",
        tag: "h4"
      },
      {},
      {
        default: () => {
          return `Vertrag`;
        }
      }
    )} <div>${validate_component(Button, "Button").$$render($$result, { size: "sm" }, {}, {
      default: () => {
        return `Felder`;
      }
    })} ${validate_component(Dropdown, "Dropdown").$$render($$result, {}, {}, {
      default: () => {
        return `${each([...localHeader.contractHeader, ...filteredHeaderItems.contractHeader].sort((a, b) => a.label.localeCompare(b.label)), (header) => {
          return `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
            default: () => {
              return `${validate_component(Checkbox, "Checkbox").$$render(
                $$result,
                {
                  checked: filteredHeaderItems.contractHeader.find((x) => x.label === header.label) === void 0
                },
                {},
                {
                  default: () => {
                    return `${escape(header.label)}`;
                  }
                }
              )} `;
            }
          })}`;
        })}`;
      }
    })}</div></div> ${validate_component(SortableTable, "SortableTable").$$render(
      $$result,
      {
        header: localHeader.contractHeader,
        data: listedHistory.filter((x) => x.historyType !== "document")
      },
      {},
      {}
    )} ${validate_component(Heading, "Heading").$$render(
      $$result,
      {
        class: "text-neutral-600 my-3",
        tag: "h4"
      },
      {},
      {
        default: () => {
          return `Urlaub`;
        }
      }
    )} ${validate_component(SortableTable, "SortableTable").$$render(
      $$result,
      {
        header: ptoHeader,
        data: listedHistory.filter((x) => x.historyType !== "document")
      },
      {},
      {}
    )} ${validate_component(Heading, "Heading").$$render(
      $$result,
      {
        class: "text-neutral-600 my-3",
        tag: "h4"
      },
      {},
      {
        default: () => {
          return `Sonstiges`;
        }
      }
    )} ${validate_component(SortableTable, "SortableTable").$$render(
      $$result,
      {
        header: elseHeader,
        data: listedHistory.filter((x) => x.historyType === "document")
      },
      {},
      {}
    )}</div>` : `<div class="space-y-2">${each(contracts, (contract, i) => {
      let history = contract.history.sort((a, b) => b.id - a.id).map((x) => ({
        ...x,
        terminated: contract.history.find((y) => y.hiredAs.includes("(aufgelöst)"))?.endDate
      }));
      localQualifications.find((x) => x.id === contract.currentHistory.qualificationId)?.title || contract.currentHistory.hiredAs;
      return `  ${validate_component(CardLayout, "CardLayout").$$render(
        $$result,
        {
          title: "",
          accordion: true,
          display: i === 0
        },
        {},
        {
          "card-header": () => {
            return `<div class="-m-6 w-full flex gap-8 text-xl items-center "><!-- HTML_TAG_START -->${parseTimeframe(contract)}<!-- HTML_TAG_END --></div> `;
          },
          default: () => {
            return `<div><div class="px-4 py-3 mb-5 space-y-2">${validate_component(ContractStatusCard, "ContractStatusCard").$$render($$result, { employee, contract }, {}, {})} <div class="flex gap-3 "><div class="flex-1 max-w-[75vw] "><div class="flex justify-between items-center">${validate_component(Heading, "Heading").$$render(
              $$result,
              {
                class: "text-neutral-600 mb-3",
                tag: "h4"
              },
              {},
              {
                default: () => {
                  return `Tarif`;
                }
              }
            )} <div>${validate_component(Button, "Button").$$render($$result, { size: "sm" }, {}, {
              default: () => {
                return `Felder`;
              }
            })} ${validate_component(Dropdown, "Dropdown").$$render($$result, {}, {}, {
              default: () => {
                return `${each(
                  [
                    ...localHeader.tariffHeader,
                    ...filteredHeaderItems.tariffHeader
                  ].sort((a, b) => a.label.localeCompare(b.label)),
                  (header) => {
                    return `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
                      default: () => {
                        return `${validate_component(Checkbox, "Checkbox").$$render(
                          $$result,
                          {
                            checked: filteredHeaderItems.tariffHeader.find((x) => x.label === header.label) === void 0
                          },
                          {},
                          {
                            default: () => {
                              return `${escape(header.label)}`;
                            }
                          }
                        )} `;
                      }
                    })}`;
                  }
                )} `;
              }
            })} </div></div> ${validate_component(SortableTable, "SortableTable").$$render(
              $$result,
              {
                header: localHeader.tariffHeader,
                data: history.filter((x) => x.historyType !== "document")
              },
              {},
              {}
            )} <div class="flex justify-between items-center">${validate_component(Heading, "Heading").$$render(
              $$result,
              {
                class: "text-neutral-600 my-3",
                tag: "h4"
              },
              {},
              {
                default: () => {
                  return `Vertrag`;
                }
              }
            )} <div>${validate_component(Button, "Button").$$render($$result, { size: "sm" }, {}, {
              default: () => {
                return `Felder`;
              }
            })} ${validate_component(Dropdown, "Dropdown").$$render($$result, {}, {}, {
              default: () => {
                return `${each(
                  [
                    ...localHeader.contractHeader,
                    ...filteredHeaderItems.contractHeader
                  ].sort((a, b) => a.label.localeCompare(b.label)),
                  (header) => {
                    return `${validate_component(DropdownItem, "DropdownItem").$$render($$result, {}, {}, {
                      default: () => {
                        return `${validate_component(Checkbox, "Checkbox").$$render(
                          $$result,
                          {
                            checked: filteredHeaderItems.contractHeader.find((x) => x.label === header.label) === void 0
                          },
                          {},
                          {
                            default: () => {
                              return `${escape(header.label)}`;
                            }
                          }
                        )} `;
                      }
                    })}`;
                  }
                )} `;
              }
            })} </div></div> ${validate_component(SortableTable, "SortableTable").$$render(
              $$result,
              {
                header: localHeader.contractHeader,
                data: history.filter((x) => x.historyType !== "document")
              },
              {},
              {}
            )} ${validate_component(Heading, "Heading").$$render(
              $$result,
              {
                class: "text-neutral-600 my-3",
                tag: "h4"
              },
              {},
              {
                default: () => {
                  return `Urlaub`;
                }
              }
            )} ${validate_component(SortableTable, "SortableTable").$$render(
              $$result,
              {
                header: ptoHeader,
                data: history.filter((x) => x.historyType !== "document")
              },
              {},
              {}
            )} ${validate_component(Heading, "Heading").$$render(
              $$result,
              {
                class: "text-neutral-600 my-3",
                tag: "h4"
              },
              {},
              {
                default: () => {
                  return `Sonstiges`;
                }
              }
            )} ${validate_component(SortableTable, "SortableTable").$$render(
              $$result,
              {
                header: elseHeader,
                data: history.filter((x) => x.historyType === "document")
              },
              {},
              {}
            )}</div> <div class="w-44 border-l border-neutral-200 pl-3">${validate_component(ContractActions, "ContractActions").$$render(
              $$result,
              {
                contract,
                currentContract: employee.currentContract,
                employee
              },
              {
                employee: ($$value) => {
                  employee = $$value;
                  $$settled = false;
                }
              },
              {}
            )} </div></div> </div></div> `;
          }
        }
      )}`;
    })}</div>`}</div>`;
  } while (!$$settled);
  $$unsubscribe_costCenters();
  $$unsubscribe_templateDocuments();
  $$unsubscribe_tariffs();
  $$unsubscribe_qualifications();
  $$unsubscribe_page();
  $$unsubscribe_listView();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
